






















import { Component, Vue, Provide,Prop } from "vue-property-decorator";

@Component({
  name: "automatiCall",
})
export default class CombinationProperty extends Vue {
  @Prop() private type: any;
  @Provide() private supplie:string = "";
  @Provide() private supplieOptions:any = [];
  @Provide() private ruleForm:any = {
    supplie: ""
  };
  @Provide() private dialogVisible:boolean = false;
  @Provide() private rules: any = {
    supplie: [{ required: true, message: '请选择', trigger: 'blur' }]
  }
  private handleClick(tab:any, event:any) {
    // 点击tab,缓存
    localStorage.setItem('tabR', tab.name);
  };
  private created() {
    this.getExtenListParam();
    this.callInfo();
  }
  private async getExtenListParam() {
    const { getDialListParam }: any = await import("@/request/getDialList");
    let res = await getDialListParam();
    if (res) {
      this.supplieOptions = res && res.supplierMap ? res.supplierMap : []; // Supplie列表
    }
  }
  private autoDialDialog() {
    const ref: any = this.$refs['ruleForm'];
    ref.validate((valid: boolean) => {
      if (valid) {
        this.autoDialStart();
      } else {
        return false;
      }
    })
  }
  // 重置
  private resetForm(formName: string) {
    let ref: any = this.$refs[formName];
    if (ref) {
      ref.resetFields();
    }
  }
  // 开始呼叫
  private async autoDialStart(){
    let otp = {supplie: this.ruleForm.supplie};
    const { dialerAutoStart }: any = await import("@/request/autoDial");
    let res = await dialerAutoStart(otp);
    if (res.commonout.code === 0) {
      localStorage.setItem("supplie", this.ruleForm.supplie);
      this.$message({
        message: 'start success',
        type: 'success'
      });
      this.dialogVisible = false;
      this.resetForm('ruleForm');
      this.autoDialNext();
    }
  }
  // 呼叫当前信息
  private async callInfo() {
    const { dialerCurrentInfo }: any = await import("@/request/autoDial");
    let res = await dialerCurrentInfo();
    if (res) {
        this.supplie = res.Supplier;
    }
  }
  // 停止呼叫
  private async autoDialStop(){
    let supplie:any = localStorage.getItem("supplie") || this.supplie;
    let otp = {supplie: supplie};
    const { dialerAutoStop }: any = await import("@/request/autoDial");
    let res = await dialerAutoStop(otp);
    if (res.commonout.code === 0) {
      this.$message({
        message: 'stop success',
        type: 'success'
      });
    }
  }
  // 呼叫下一个
  public async autoDialNext(){
    const { dialerAutoNext }: any = await import("@/request/autoDial");
    let res = await dialerAutoNext();
     if (res.commonout.code === 0) {
        sessionStorage.setItem("phone", res.phone); // lee 2021-07-16 T26887
       let routeData: any = this.$router.resolve({
        path: "collectionDetail",
        query: {
          id: res.caseid,
          type: this.type, // 催收
          orderId: res.orderid,
          autoCall: '1',// lee 2021-07-16 T26887  添加自动拨打的标识
          // phone: res.phone, // lee 2021-07-16 T26887
          phoneobject: res.phoneobject
        }
      });
      window.open(routeData.href, "_self");
    }
  }
}
